exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito);", ""]);

// module
exports.push([module.id, "body,html{margin:0;padding:0;font-family:Nunito,sans-serif;background-color:#fbfbfb;color:#444}.SplitPane .Resizer.vertical{min-width:1px;background-color:#ddd;cursor:col-resize}.SplitPane .Pane.vertical.Pane1{overflow-y:scroll}.SplitPane .Pane1::-webkit-scrollbar{display:none}.icon{position:relative;width:24px;top:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main.css
// module id = 597
// module chunks = 1